import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import Dashboard from './components/Dashboard';
import AuthPage from './components/AuthPage';
import Services from './components/services';
import AboutPage from './components/About';
import Error404Page from './components/Error404Page';
import ContactForm from './components/Contact';
import Pricing from './components/Pricing';
import ForgotPassword from './components/ForgotPassword';
import TermsOfService from './components/TermsOfService';


function App() {
 

  return (
    <Router>
      <main className="min-h-screen bg-gray-100">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about-us" element={<AboutPage />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/auth/login" element={<AuthPage />} />
          <Route path="/auth/register" element={<AuthPage />} />
          <Route path="/contact" element={<ContactForm />} />
          <Route path='/auth/forgot-password' element={<ForgotPassword/>}/>
          <Route path='/terms-of-service' element={<TermsOfService/>}/>

          {/* Dashboard Route */}
          <Route path="/dashboard/*" element={<Dashboard />} />
        

          {/* Catch-all route for undefined paths */}
          <Route path="*" element={<Error404Page />} />
        </Routes>
      </main>
    </Router>
  );
}

export default App;
